<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Batch Apply Test Package" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['add prep process']">
      <template #gated-content>
        <TestPackageApplyTestPackageForm @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import { notificationOptions } from '@/shared/toast-notification-options'
import { submissionNotifications } from '@/shared/notifications'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import TestPackageApplyTestPackageForm from '@/components/lab/testpackage/TestPackageApplyTestPackageForm'
import TestPackageModel from '@/models/lab/TestPackageModel'

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'TestPackageApplyTestPackage',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TestPackageApplyTestPackageForm
  },
  data () {
    return {
      loading: true,
      submission_id: this.$route.params.submission_id || null,
      submission: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
        ]
      }
    },
  },
  async mounted () {
    this.loading = true

    this.loading = false
  },
  methods: {
    async submit (form_data) {
      try {
        const test_package_model = new TestPackageModel({ id: form_data.selected_test_package })

        await test_package_model.apply({
          submissions: form_data.selected_submissions.map(submission => submission.id)
        })

        this.editSuccess()
        this.$router.push(`/submissions`)
      } catch ({ response }) {
        const { status, data } = response.response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        })
      }
    }
  },
  notifications: submissionNotifications
}
</script>
